import { SemanticUI } from '@iterable/deprecated_react_components';
import styled from 'styled-components';

export const StyledDropdown = styled(SemanticUI.Dropdown)`
  flex: 3 !important;
`;

export const StyledInnerDropdownMenu = styled(SemanticUI.Dropdown.Menu)`
  &&&& {
    left: 0;
    overflow: hidden;
    max-height: unset;
    padding: 0;

    /* !important are being used here as a last resort here */
    margin: 0 !important;
    border-radius: 0 !important;
    border: 0;
  }

  .menu {
    > .item {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
`;
